import axios from "@/libs/api.request";
export function getCenterPic(params) {
    return axios.request({
        url: "WebFileInfo/getFileAllList",
        method: "get",
        params:params
    })
}

export function submitCenterPic(params) {
    return axios.request({
        url: "UploadFile/UploadBatch",
        method: "POST",
        headers: {
            'Content-Type': 'multipart/form-data',
          },
        data:params,
    })
}

export function submitHomeFirst(params) {
    return axios.request({
        url: "UploadFile/HomeCreateUpdateDel",
        method: "POST",
        headers: {
            'Content-Type': 'multipart/form-data',
          },
        data:params,
    })
}